import React from 'react';
import ImgIconComp from '../imgcomp';
import { WoboFileUploadService } from '../../../src/services/fileupload.service'

// List Topic Attachment
class TopicAttachment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'topic',
      showMenuClose: false,
    };
    this.deleteTopicAttach = this.deleteTopicAttach.bind(this);
    this.handleFileDownload = this.handleFileDownload.bind(this);
    this.showCloseMenu = this.showCloseMenu.bind(this);
    this.hideCloseMenu = this.hideCloseMenu.bind(this);
    this.renderFileName = this.renderFileName.bind(this);
  }

  deleteTopicAttach(topicId, id, type, fileSignature) {
    const { isFUSEnabled  } = this.props;
    if (isFUSEnabled && fileSignature) {
      WoboFileUploadService.delete(fileSignature)
    }
    $.get(`${wbConfig.baseUrl}/meeting/deleteAttachment`, { id, meeting_id:this.props.meeting.id,json: true }, (resp) => {
      if (resp.status == 'ok') {
        create_topic('meet', {
          action: 'delete_topic_attc',
          type: 'topic',
          data: { id },
          topicId,
        });
      }
    });
    this.props.deleteTopicAttach(topicId, id);
  }

  handleFileDownload(e, item) {
    e.preventDefault();
    const { isNoAttachmentDownload  } = this.props;
    if (!isNoAttachmentDownload) return;
    if (item.fusType == 1 && item.fusStatus == 1) {
      const link = document.createElement('a');
      let fileSignature = item.fileSignature ? item.fileSignature : item.file_signature
      const url = `${wbConfig.baseUrl}`+ '/vnext/fus/api/v1/download/' + fileSignature
      WoboFileUploadService.download(url).then(async (res)=>{
          const blob = await res.blob();
          const blobUrl = URL.createObjectURL(new Blob([blob]));
          link.href = blobUrl;
          link.target = "_blank";
          link.setAttribute(
              "download",
              item.file_name
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      })
    } else if(item.fusType != 1) {
      return window.open(item.path, '_blank');
    }
  }

  showCloseMenu(id) {
    const topicMiddleDet = this.props.topicMiddle;
    const { currentUser } = this.props;
    const { userPermission } = this.props;
    if ((userPermission.notesAccess || currentUser.id == topicMiddleDet.added_by)) {
      this.setState({
        showMenuClose: id,
      });
    }
  }

  hideCloseMenu() {
    this.setState({
      showMenuClose: false,
    });
  }

  renderFileName(file) {
    let fusType = parseInt(file.fusType) ? parseInt(file.fusType) : parseInt(file.fus_type);
    let fusStatus = parseInt(file.fusStatus) ? parseInt(file.fusStatus) : parseInt(file.fus_status);
    if (!fusType) {
        return <div className="truncateText dispIB floatLeft" style={{minWidth: '69%', width: '69%', paddingRight: '5px', fontSize: '13px',}} onClick={e => this.handleFileDownload(e, file)}>{file.file_name}</div>
    } else if (fusType) {
        if (fusStatus == 1) {
          return <div className="truncateText dispIB floatLeft" style={{minWidth: '69%', width: '69%', paddingRight: '5px', fontSize: '13px',}} onClick={e => this.handleFileDownload(e, file)}>{file.file_name}</div>
        } else if (fusStatus == 2) {
          return <div className="truncateText dispIB floatLeft" style={{minWidth: '69%', width: '69%', paddingRight: '5px', fontSize: '13px',}}>{file.file_name} (processing)</div>
        }  else if (fusStatus == 5) {
          return <div className="truncateText dispIB floatLeft" style={{minWidth: '69%', width: '69%', paddingRight: '5px', fontSize: '13px',}}>{file.file_name} (infected file, deleted)</div>
        } else {
          return <div className="truncateText dispIB floatLeft" style={{minWidth: '69%', width: '69%', paddingRight: '5px', fontSize: '13px',}}>{file.file_name}</div>
        }
    }
  }
  render() {
    const topicMiddleDet = this.props.topicMiddle;
    const { currentUser } = this.props;
    const { userPermission } = this.props;
    let enableDiv = false;
    const { topicFile } = this.props;
    const { isNoAttachmentDownload } = this.props;
    if (userPermission.notesAccess || currentUser.id == topicMiddleDet.added_by) {
      enableDiv = true;
    }
    const fileCursor = !!(isNoAttachmentDownload);
    return (
      <div className="wb-table tabLayFix  Row " style={{ cursor: fileCursor ? 'pointer' : 'move' }}>
        {
          topicFile.map(file => (
            <div key={`topic_file_${topicMiddleDet.id}_${file.id}`} className="wb-table-row " data-type="topic" style={{ cursor: fileCursor ? 'pointer' : 'move' }} onMouseEnter={() => this.showCloseMenu(file.id)} onMouseLeave={() => this.hideCloseMenu()}>
              <div
                className="wb-table-col wb-table-col-tag tagForAi"
                style={{
                  display: 'inline-block', padding: '0px', verticalAlign: 'middle', cursor: fileCursor ? 'pointer' : 'move',
                }}
              >
                <div className="meeting-tag-wrapper">
                  <div className="wb-table-col-edit-title-desc wrap  " data-view-acces="true">
                    <div className="meeting-tag-options" data-tag="14" data-type="attch" style={{ height: '20px', cursor: fileCursor ? 'pointer' : 'move' }} />
                  </div>
                </div>
              </div>
              <div
                className="wb-table-col wb-table-col-title titleAlignLeft"
                data-topic-id="7306"
                style={{
                  width: '90%', display: 'inline-block', verticalAlign: 'middle', padding: '4px 0px 4px 3px', fontSize: '12px', cursor: fileCursor ? 'pointer' : 'move',
                }}
              >
                <div className="topicConetentSec">
                  <div className="topic-section-div attachemntTopicSec">
                    <div>
                      <div className="ai-div-section width100  dispIB truncateText">
                        {
                          this.renderFileName(file)
                        }
                        <div
                          className="smallFont9 truncateText dispIB topicAttachmentDiv"
                          style={{
                            fontSize: '10px', color: '#8C9EA2', letterSpacing: '-0.16px', lineHeight: '20px', fontStyle: 'normal',
                          }}
                        >
                          Added by
                          {' '}
                          {`${file.firstname} ${file.lastname.charAt(0).toUpperCase()}`}
                        </div>
                        <div style={{ width: '11%' }} />
                      </div>
                      {
                        enableDiv && this.state.showMenuClose == file.id
                        && (
                        <div className="floatRight dispIB hideAttachMenu closeImg" onClick={() => this.deleteTopicAttach(topicMiddleDet.id, file.id, this.state.type, file.fileSignature )}>
                          <div className="dispIB closeImg">
                            <ImgIconComp id="close_topic_take" class="memberPic" width="13" height="13" />
                          </div>
                        </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
      }
      </div>
    );
  }
}
export default TopicAttachment;
